<template>
    <label v-if="label">{{ label }}:</label>
    <select
            :value="modelValue"
            v-bind="{
            ...$attrs,
            onChange: ($event) => { $emit('update:modelValue', $event.target.value) }
        }"
    >
        <option value="" disabled>{{ placeholder }}</option>
        <slot/>
    </select>
</template>

<script>
export default {
    name: 'BaseSelect',
    props: {
        label: String,
        placeholder: String,
        modelValue: [String, Number]
    }
}
</script>

<style lang="scss" scoped>
    label {
        display: block;
        font-weight: 700;
        margin-bottom: .5em;
    }

    select {
        display: block;
        width: 100%;
        padding: 1.3em;
        outline: 0;
        border: 2px solid var(--colorInputBorder);
        font-family: inherit;
        background: transparent;
        border-radius: 0;

        option {
            color: #000
        }
    }
</style>
